
import Vue, {PropType} from "vue";
import {SimpleAttributeValue} from "../../../model/cart/LocalCartItem";
import {BooleanGridSymbol} from "../../../util/ui/grid/BooleanCellRenderer";

export default Vue.extend({
  name: "BooleanAttributeValue",
  props: {
    attrValue: {
      type: Object as PropType<SimpleAttributeValue>,
      default: () => ({
        value: "",
      }),
    },
  },
  computed: {
    symbol(): string {
      return this.attrValue.value || this.attrValue.value === "true" ? BooleanGridSymbol.TRUE : BooleanGridSymbol.FALSE;
    },
  },
});
